const SUM_ARRAY_DESCRIPTION = `
Problem Statement
You are given an integer array nums. Your goal is to return the sum of the elements in the array.

Example 1: nums = [3,3,5,1,0]
Output: 12
Explanation: Start at index 0, add 3 to the sum. Then add 3 to the sum. Then add 5 to the sum. Then add 1 to the sum. Then add 0 to the sum. The sum is 12.

Task Requirements:
- You may use variable names in your description. If you do, you are restricted to using only the following 3 variables in your explanation:
  1. nums: the input array
  2. counter: a variable that keeps track of the current index in the array in a loop
  3. sum: a variable to keep track of the sum of the array
`.trim();

const JUMP_GAME_DESCRIPTION = `
Problem Statement
You are given an integer array nums where nums[i] represents the maximum jump length from index i. Your goal is to determine if you can reach the last index after being initially positioned at the array's first index.

Example 1: nums = [2,1,2,0,1]
Output: true
Explanation: Jump 2 steps from index 0 to 2, then 2 steps to the last index.

Example 2: nums = [3,2,1,0,4]
Output: false
Explanation: You will always arrive at index 3 no matter what. Its maximum jump length is 0, which makes it impossible to reach the last index.

Task Requirements:
- You must use a greedy algorithm approach to solve this problem.
- You may use variable names in your description. If you do, you are restricted to using only the following 3 variables in your explanation:
  1. nums: the input array
  2. counter: a variable that keeps track of the current index in the array in a loop
  3. tracker: a variable to keep track of the farthest index that can be reached from the current index
`.trim();

const LOOP_ARRAY_DESCRIPTION = `
Problem Statement
You are given an integer array nums. Your goal is to return the sum of every other element in the array starting from the second element.

Example 1: nums = [3,3,5,1,0]
Output: 4
Explanation: Start at index 1, add 3 to the sum. Then skip index 2. At index 3, add 1 to the sum. Skip index 4. The sum is 4.

Task Requirements:
- You may use variable names in your description. If you do, you are restricted to using only the following 3 variables in your explanation:
  1. nums: the input array
  2. counter: a variable that keeps track of the current index in the array in a loop
  3. sum: a variable to keep track of the sum of the array
`.trim();

const STARTER_CODE = `# 📝 Welcome!

# Useful Python documentation links:
#   https://docs.python.org/3/library/functions.html
#   https://docs.python.org/3/library/stdtypes.html#lists
#   https://docs.python.org/3/reference/compound_stmts.html#for
#   https://docs.python.org/3/reference/compound_stmts.html#if
#   https://docs.python.org/3/library/math.html
# Good luck! 🚀

def can_jump(nums):
  # Fill in your logic here.
  pass

# --- Test Cases ---
test_case_1 = [2, 1, 2, 0, 1]
print(f"Test Case 1: {test_case_1}")
print(f"Expected: True, Your code's output: {can_jump(test_case_1)}")

test_case_2 = [3, 2, 1, 0, 4]
print(f"Test Case 2: {test_case_2}")
print(f"Expected: False, Your code's output: {can_jump(test_case_2)}")
`;

export const PROBLEM_SEQUENCE = ['example', 'mini', 'main'];
export const FINAL_PROBLEM_ID = 'main';
export const IDE_PROBLEM_ID = 'main';

export const PROBLEMS = {
  example: {
    id: 'example',
    title: 'Guided Example: Sum of Array',
    description: SUM_ARRAY_DESCRIPTION,
    starterCode: STARTER_CODE,
    readOnly: true,
    prefilledSteps: [
      {
        id: 'example-1',
        description: 'Initialize variable sum = 0 to keep track of sum.',
        indent: 0,
        isCorrect: true,
        feedback: '',
        incompletePlaceholder: false
      },
      {
        id: 'example-2',
        description: 'Iterate over all elements in the array.',
        indent: 0,
        isCorrect: true,
        feedback: '',
        incompletePlaceholder: false
      },
      {
        id: 'example-3',
        description: 'Add the number to the running sum.',
        indent: 1,
        isCorrect: true,
        feedback: '',
        incompletePlaceholder: false
      },
      {
        id: 'example-4',
        description: 'Return the value stored in sum.',
        indent: 0,
        isCorrect: true,
        feedback: '',
        incompletePlaceholder: false
      }
    ]
  },
  mini: {
    id: 'mini',
    title: 'Warm-up: Loop Array',
    description: LOOP_ARRAY_DESCRIPTION,
    starterCode: STARTER_CODE,
  },
  main: {
    id: 'main',
    title: 'Full Task: Jump Game',
    description: JUMP_GAME_DESCRIPTION,
    starterCode: STARTER_CODE,
  },
};
